export interface LockSubjectResponse {
    success: boolean;
}
